<section class="cookie-banner" aria-labelledby="cookie-banner-title">
  <div class="cookie-copy">
    <h2 id="cookie-banner-title">Your cookie preferences</h2>
    <p>
      <span>We use essential cookies to run the platform and optional cookies for analytics.</span>
      <button type="button" class="cookie-policy-link" (click)="modalOpen(true)">
        Cookie policy
      </button>
    </p>
  </div>
  <div class="cookie-actions">
    <p-button
      label="Manage preferences"
      severity="secondary"
      size="small"
      [outlined]="true"
      (onClick)="modalOpen(false)" />
    <p-button label="Accept all cookies" size="small" (onClick)="acceptCookies()" />
  </div>
</section>
